import type { PermissionsCheck } from '@openx/types/permissionsCheck';
import { unpackAcl } from '@openx/utils/permission/unpackAcl';
import { useCallback, useMemo } from 'react';
import { useAuth } from '../../../components/AuthContext/context';

export function useIsAllowed() {
  const { session } = useAuth();

  const state = useMemo(() => {
    if (!session) {
      return null;
    }

    return {
      accessAccount: session?.exchange_session?.account,
      accessUser: session?.exchange_session?.user,
      accountAcl: unpackAcl(session?.exchange_session?.account?.compiled_acl),
      aclList: unpackAcl(session?.exchange_session?.compiled_acl),
      aclMapping: session?.exchange_session?.acl_mapping,
      instance: session?.exchange_session?.instance,
      userAcl: unpackAcl(session?.exchange_session?.user?.compiled_acl),
    };
  }, [session]);

  const isAllowed = useCallback(
    (check: PermissionsCheck): boolean => {
      if (!state) {
        return false;
      }

      return check(state);
    },

    [state]
  );

  return { ...state, isAllowed };
}
